import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BsGithub } from "react-icons/bs";
import { CgWebsite } from "react-icons/cg";
import { MdOpenInNew } from "react-icons/md";

import furnihubImg      from "../../Assets/Projects/furnihub.png";
import pastryImg        from "../../Assets/Projects/pastryParadise.png";
import dhakaImg         from "../../Assets/Projects/dhakaLocalBus.png";
import shondhanImg      from "../../Assets/Projects/shondhan.png";
import cateringImg      from "../../Assets/Projects/daffodilCatering.png";

const ALL = "All";

const projects = [
  {
    id: "robolink",
    title: "RoboLink – Wireless Robot Controller",
    short: "Control your robot wirelessly. Flutter app with drag-and-drop UI editor, live MJPEG streaming, Wi-Fi UDP + Bluetooth & open-source Arduino Library.",
    screenshots: [
      "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/WhatsApp%20Image%202026-02-25%20at%201.16.41%20AM-vLK5FeJowGMbctgnaThFOq3HeNXxjQ.jpeg",
      "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/WhatsApp%20Image%202026-02-25%20at%201.16.43%20AM%20%282%29-UHJB3mW1LCG7eg9SvXvcdbyyRwySKo.jpeg",
      "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/WhatsApp%20Image%202026-02-25%20at%201.16.42%20AM%20%281%29-BBrTmTSgtwTtWIyVp2S8RBimO0rn6J.jpeg",
      "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/WhatsApp%20Image%202026-02-25%20at%201.16.43%20AM-x8vnQOjgOAgtEodWUIleqiLOJmo1Cw.jpeg",
    ],
    gradient: "linear-gradient(135deg,#54c5f8,#0175c2)",
    category: "Hardware & IoT",
    tags: ["Flutter","Arduino","ESP32","Wi-Fi UDP","Bluetooth"],
    github: "https://github.com/sakibahmedshanto/RoboLink",
    demo:   "https://play.google.com/store/apps/details?id=com.ahmedapps.robolink",
    detailId: "robolink",
    highlight: "200+ Downloads · robolink.studio",
  },
  {
    id: "rahiee",
    title: "Rahiee.AI – AI HR & Attendance System",
    short: "AI-powered cross-platform app (iOS + Android) with real-time attendance, admin dashboard & schedule management. Sole developer — live on Apple App Store.",
    screenshots: [
      "/rahiee-screenshots/employee_check_in_with_selfie.jpg",
      "/rahiee-screenshots/admin_dashboard.jpg",
      "/rahiee-screenshots/employee_todays_schedule.jpg",
      "/rahiee-screenshots/admin_attendance_summary.jpg",
    ],
    gradient: "linear-gradient(135deg,#a78bfa,#7c3aed)",
    category: "AI & HR Tech",
    tags: ["Flutter","iOS","Android","Firebase","GetX"],
    github: "https://github.com/sakibahmedshanto",
    demo:   "https://apps.apple.com/app/rahiee-ai",
    detailId: "rahiee",
    highlight: "Live on App Store",
  },
  {
    id: "robolink-rn",
    title: "RoboLink – React Native Robot Controller",
    short: "React Native CLI robot controller with drag-and-drop UI builder, Bluetooth & Wi-Fi UDP. Built for Mobile App Dev academic course — live on Play Store.",
    screenshots: [
      "/robolink%20react%20native/custom_virtual_gamepad.webp",
      "/robolink%20react%20native/customizing_rearranging_buttons_and_joysticks.webp",
      "/robolink%20react%20native/wifi_udp_transmission.webp",
      "/robolink%20react%20native/code_help.webp",
    ],
    gradient: "linear-gradient(135deg,#f472b6,#7c3aed)",
    category: "Hardware & IoT",
    tags: ["React Native","Arduino","ESP32","Bluetooth","Wi-Fi UDP"],
    github: "https://github.com/sakibahmedshanto/Robolink",
    demo:   "https://play.google.com/store/apps/details?id=com.robolinkiut",
    detailId: "robolink-rn",
    highlight: "100+ Downloads · v3.0",
  },
  {
    id: "furnihub",
    title: "FurniHub – AR Furniture E-commerce",
    short: "Android e-commerce app with ARCore — place, scale & rotate real furniture in your living space before purchase.",
    img: furnihubImg,
    gradient: "linear-gradient(135deg,#f59e0b,#ef4444)",
    category: "AR & E-commerce",
    tags: ["Flutter","ARCore","Firebase","Android"],
    github: "https://github.com/sakibahmedshanto/Furnihub_Augmented_Reality_App",
    detailId: "furnihub",
  },
  {
    id: "shondhan",
    title: "Shondhan – AR Property Discovery",
    short: "Led 4-member team building AI + AR real estate platform with ARCore, price prediction (Flask + scikit-learn), Google Maps & neighbourhood safety scores.",
    img: shondhanImg,
    gradient: "linear-gradient(135deg,#06b6d4,#3b82f6)",
    category: "AR & Real Estate",
    tags: ["Flutter","ARCore","Flask","ML","PostgreSQL"],
    github: "https://github.com/sakibahmedshanto/shondhan",
    detailId: "shondhan",
  },
  {
    id: "dhaka-navigator",
    title: "Dhaka City Navigator",
    short: "Offline-first Android bus route app with intelligent multi-bus transfer detection. 4000+ downloads, 4.2★ on Google Play Store.",
    img: dhakaImg,
    gradient: "linear-gradient(135deg,#4ade80,#22c55e)",
    category: "Navigation & Transport",
    tags: ["Flutter","Hive","Offline","Android"],
    github: "https://github.com/sakibahmedshanto/DhakaLocalBus",
    demo:   "https://play.google.com/store/apps/details?id=com.ahmedapps.dhakalocalbus",
    detailId: "dhaka-navigator",
    highlight: "4000+ downloads · 4.2★",
  },
  {
    id: "pastry",
    title: "Pastry Paradise – Bakery E-commerce",
    short: "Full-stack e-commerce app for a local bakery with Google Sign-In, real-time Firestore order management, push notifications & Play Store deployment.",
    img: pastryImg,
    gradient: "linear-gradient(135deg,#fb923c,#f97316)",
    category: "E-commerce",
    tags: ["Flutter","Firebase","Firestore","REST"],
    github: "https://github.com/sakibahmedshanto/pastryparadise",
    demo:   "https://play.google.com/store/apps/details?id=com.sakibahmedshanto.pastryparadise",
    detailId: "pastryparadise",
  },
  {
    id: "catering",
    title: "Sat Sotero – University Catering System",
    short: "Meal pre-ordering system for IUT's dormitory with advanced scheduling, 24-hr advance order capability, and Google Sign-In authentication.",
    img: cateringImg,
    gradient: "linear-gradient(135deg,#818cf8,#6366f1)",
    category: "Management System",
    tags: ["Flutter","Firebase","Scheduling"],
    github: "https://github.com/sakibahmedshanto/Daffodil_Catering_Service",
    detailId: "catering",
  },
];

const allCategories = [ALL, ...Array.from(new Set(projects.map((p) => p.category)))];

function ProjectCard({ project }) {
  const navigate = useNavigate();

  return (
    <div
      className="proj-card"
      onClick={() => project.detailId && navigate(`/project/${project.detailId}`)}
      style={{ cursor: project.detailId ? "pointer" : "default" }}
    >
      {/* Image / screenshot grid */}
      <div className="proj-img-wrap">
        {project.screenshots ? (
          <div className="proj-screenshot-grid">
            {project.screenshots.slice(0, 4).map((src, i) => {
              const imgSrc = src.startsWith('/') ? `${process.env.PUBLIC_URL}${src}` : src;
              return (
                <img key={i} src={imgSrc} alt={`${project.title} screenshot ${i + 1}`} className="proj-screenshot-thumb" />
              );
            })}
          </div>
        ) : (
          <img src={project.img} alt={project.title} className="proj-img" />
        )}
        <div className="proj-img-overlay" />
        {project.highlight && (
          <span className="proj-highlight-badge" style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            {project.demo?.includes("apps.apple.com") && (
              <img src={`${process.env.PUBLIC_URL}/logos/appstore.png`} alt="App Store" style={{ height: "14px", width: "auto" }} />
            )}
            {project.demo?.includes("play.google.com") && (
              <img src={`${process.env.PUBLIC_URL}/logos/playstore.png`} alt="Play Store" style={{ height: "14px", width: "auto" }} />
            )}
            {!project.demo && "⭐"}
            <span>{project.highlight}</span>
          </span>
        )}
      </div>

      <div className="proj-body">
        <span className="proj-category">{project.category}</span>
        <h3 className="proj-title">{project.title}</h3>
        <p className="proj-desc">{project.short}</p>

        <div className="proj-tags">
          {project.tags.map((t) => (
            <span className="project-tech-tag" key={t}>{t}</span>
          ))}
        </div>

        <div className="proj-actions" onClick={(e) => e.stopPropagation()}>
          {project.github && (
            <a href={project.github} target="_blank" rel="noreferrer" className="project-btn project-btn-secondary">
              <BsGithub /> Code
            </a>
          )}
          {project.demo && (
            <a href={project.demo} target="_blank" rel="noreferrer" className="project-btn project-btn-primary">
              <CgWebsite /> Demo
            </a>
          )}
          {project.detailId && (
            <button
              className="project-btn project-btn-secondary"
              onClick={() => navigate(`/project/${project.detailId}`)}
            >
              <MdOpenInNew /> Details
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

function ProjectsSection() {
  const [filter, setFilter] = useState(ALL);
  const visible = filter === ALL ? projects : projects.filter((p) => p.category === filter);

  return (
    <section id="projects" className="sp-section">
      <div className="sp-container">
        <div className="sp-section-header">
          <span className="section-label">What I've built</span>
          <h2 className="section-title">
            My <span className="gradient-text">Projects</span>
          </h2>
          <p className="section-subtitle">
            Production apps on stores, AR experiences, IoT hardware bridges, and open-source libraries.
          </p>
        </div>

        {/* Filter tabs */}
        <div className="proj-filters">
          {allCategories.map((c) => (
            <button
              key={c}
              className={`proj-filter-btn${filter === c ? " active" : ""}`}
              onClick={() => setFilter(c)}
            >
              {c}
            </button>
          ))}
        </div>

        {/* Grid */}
        <div className="proj-grid">
          {visible.map((p) => (
            <ProjectCard key={p.id} project={p} />
          ))}
        </div>

        {/* GitHub CTA */}
        <div className="proj-github-cta">
          <p style={{ color: "#94a3b8", marginBottom: "20px" }}>
            More projects &amp; open-source contributions on GitHub
          </p>
          <a href="https://github.com/sakibahmedshanto" target="_blank" rel="noreferrer" className="btn-primary-hero">
            View GitHub Profile ↗
          </a>
        </div>
      </div>
    </section>
  );
}

export default ProjectsSection;
